import { render, staticRenderFns } from "./FeedContainer.vue?vue&type=template&id=5bce7590&"
import script from "./FeedContainer.vue?vue&type=script&lang=ts&"
export * from "./FeedContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports